import constants from '../constants.js';

const RailSupplierFareClassName = {
  displayName: 'Supplier Fare Class Names',
  dataAt: 'FareClasses.$railSupFareClassItem.SupplierFareClassName',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const RailSupplierFareClassesGroupType = {
  displayName: 'Group Type',
  dataAt: 'FareClasses.$railSupFareClassItem.GroupType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierFareClassesBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'FareClasses.$railSupFareClassItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const RailSupplierFareClassesTitle = {
  displayName: 'Title',
  dataAt: 'FareClasses.$railSupFareClassItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierFareBrandNameMappingDisplayName = {
  displayName: 'Display Name',
  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping.Display',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierFareBrandNameMappingName = {
  displayName: 'Fare Name',
  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping.FareName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierFareBrandNameMappingsGridItem = {
  displayName: 'Fare Brand Name Mappings',
  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [RailSupplierFareBrandNameMappingName, RailSupplierFareBrandNameMappingDisplayName],
  endpoint: 'RailSuppliers',
  routeParamId: 'railSupId',
  removeParamId: 'railSupFareBrandNameMapping',
  canDelete: true
};

const RailSupplierFareClassesGridItem = {
  displayName: 'Fare Class',
  dataAt: 'FareClasses.$railSupFareClassItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [RailSupplierFareClassesTitle, RailSupplierFareClassesBookingCodes, RailSupplierFareClassesGroupType, RailSupplierFareClassName],
  endpoint: 'RailSuppliers',
  routeParamId: 'railSupId',
  removeParamId: 'railSupFareClassItem',
  canDelete: true
};

const RailSupplierModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const RailSupplierModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const RailSupplierCreatedOn = {
  displayName: 'Created On',
  dataAt: 'CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const RailSupplierCreatedBy = {
  displayName: 'Created By',
  dataAt: 'CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const RailSupplierFareRulesDocument = {
  displayName: 'Fare Rules Document',
  dataAt: 'FareRulesDocument',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'RailFareRule',
  uploadType: 'pdf'
};

const RailSupplierFareClasses = {
  displayName: 'Fare Classes',
  dataAt: 'FareClasses',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: RailSupplierFareClassesGridItem,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Group Type', key: 'GroupType'}]
};

const RailSupplierFareBrandNameMappings = {
  displayName: 'Fare Brand Name Mappings',
  dataAt: 'FareBrandNameMappings',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: RailSupplierFareBrandNameMappingsGridItem,
  gridCols:
    [{name: 'Fare Name', key: 'FareName'},
      {name: 'Display', key: 'Display'}]
};

const RailSupplierSupplierLogoUrl = {
  displayName: 'Supplier Logo Url',
  dataAt: 'SupplierLogoUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'RailSupplier',
  uploadType: 'image'
};

const RailSupplierCheckInUrl = {
  displayName: 'Check-in Url',
  dataAt: 'CheckInUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierId = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSuppliersAdminPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Admin',
  children: [RailSupplierCreatedBy, RailSupplierCreatedOn, RailSupplierModifiedBy, RailSupplierModifiedOn]
};

const RailSuppliersInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [RailSupplierId, RailSupplierTitle, RailSupplierCode, RailSupplierCheckInUrl, RailSupplierSupplierLogoUrl, RailSupplierFareClasses, RailSupplierFareBrandNameMappings, RailSupplierFareRulesDocument]
};

const RailSupplierCode = {displayName: 'Code', dataAt: 'Code', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const RailSupplierTitle = {
  displayName: 'Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSuppliersTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [RailSuppliersInfoPanel, RailSuppliersAdminPanel],
  endpoint: 'RailSuppliers'
};

const RailSuppliersAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Rail Supplier',
  data: {Title: '', Code: ''},
  dataAt: '',
  children: [RailSupplierTitle, RailSupplierCode],
  endpoint: 'RailSuppliers'
};

const RailSuppliersResource = {
  displayName: 'Rail Supplier',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: 'fa-train',
  children: [RailSuppliersTabs],
  endpoint: 'RailSuppliers',
  routeParamId: 'railSupId'
};

const RailSuppliersList = {
  rootNode: true,
  displayName: 'Rail Suppliers',
  endpoint: 'RailSuppliers',
  iconClass: 'fa-train',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: RailSuppliersResource,
  gridAdd: RailSuppliersAddResource,
  gridCols:
    [{name: 'Title', key: 'Title'},
      {name: 'Code', key: 'Code'}]
};

export default {
  RailSuppliersList,
  RailSuppliersResource,
  RailSuppliersAddResource,
  RailSuppliersTabs,
  RailSupplierTitle,
  RailSupplierCode,
  RailSuppliersInfoPanel,
  RailSuppliersAdminPanel,
  RailSupplierId,
  RailSupplierCheckInUrl,
  RailSupplierSupplierLogoUrl,
  RailSupplierFareClasses,
  RailSupplierFareBrandNameMappings,
  RailSupplierFareRulesDocument,
  RailSupplierCreatedBy,
  RailSupplierCreatedOn,
  RailSupplierModifiedBy,
  RailSupplierModifiedOn,
  RailSupplierFareClassesGridItem,
  RailSupplierFareBrandNameMappingsGridItem,
  RailSupplierFareClassesTitle,
  RailSupplierFareBrandNameMappingName,
  RailSupplierFareBrandNameMappingDisplayName,
  RailSupplierFareClassesBookingCodes,
  RailSupplierFareClassesGroupType,
  RailSupplierFareClassName
}



// WEBPACK FOOTER //
// ./src/config/fields/railSuppliers.js